import { colors } from '@peachjar/components';
import { css } from 'react-emotion';

const { prussian, platinum } = colors;

export const styles = {
  wrapper: css`
    background-color: #fff;
    border-radius: 3px;
    padding: 5rem;
  `,
  pageHeader: css`
    color: ${prussian};
    font-size: 25px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  `,
  pageText: css`
    color: ${prussian};
    font-size: 16px;
    margin-top: 1rem;
  `,
  label: css`
    font-weight: 700;
    color: ${prussian};
    margin-top: 2rem;
  `,
  emailSubject: css`
    width: 100%;
    height: 40px;
    border-radius: 3px;
    background-color: ${platinum};
  `,
  emailMessage: css`
    width: 100%;
    border-radius: 3px;
    background-color: ${platinum};
    padding: 0.5rem 1rem;
  `,
  emailMessageText: css`
    padding-top: 1rem;
  `,
  emailSubjectText: css`
    padding-top: 0.5rem;
    padding-left: 1rem;
    color: ${prussian};
  `,
  emailInput: css`
    width: 420px;
    margin-top: 1rem;
  `,
  emailInputWrapper: css`
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
  `,
  emailSmallSignatureText: css`
    font-size: 13px;
  `,
  continueButtonWrapper: css`
    display: flex;
    justify-content: flex-end;
    margin-top: 3rem;
  `,
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/school/containers/WebsiteButtonRequestTab.css.js